// Correções pós-homologação, itens 2/3 — padrão brasileiro de competência é
// MM-AAAA (ex.: 08-2026); o backend continua guardando/comparando
// internamente como AAAA-MM (mais simples de ordenar), mas a interface
// NUNCA deve pedir/mostrar AAAA-MM ao usuário.
export const onlyDigits = (v) => (v || "").replace(/\D/g, "");

// Digitação livre (só números) -> máscara MM-AAAA automática.
export const maskCompetencia = (v) => {
  const d = onlyDigits(v).slice(0, 6);
  if (d.length <= 2) return d;
  return `${d.slice(0, 2)}-${d.slice(2)}`;
};

// AAAA-MM (formato interno devolvido pelo backend) -> MM-AAAA (exibição).
export const competenciaFromInternal = (yyyyMM) => {
  const m = /^(\d{4})-(\d{2})$/.exec(yyyyMM || "");
  return m ? `${m[2]}-${m[1]}` : (yyyyMM || "");
};

// MM-AAAA (o que o usuário digitou) -> AAAA-MM — o backend já aceita
// MM-AAAA diretamente (normaliza sozinho), mas isso serve para validar/
// pré-visualizar no frontend antes de enviar.
export const competenciaToInternal = (mmYYYY) => {
  const m = /^(\d{2})-(\d{4})$/.exec(mmYYYY || "");
  return m ? `${m[2]}-${m[1]}` : "";
};

export const isValidCompetencia = (mmYYYY) => {
  const m = /^(\d{2})-(\d{4})$/.exec(mmYYYY || "");
  if (!m) return false;
  const month = parseInt(m[1], 10);
  return month >= 1 && month <= 12;
};
